import { useState, useRef, useEffect } from "react";
import { embedDashboard } from "amazon-quicksight-embedding-sdk";
import { Box } from "../../components/Box";
import { LoadingOver } from "../../components/LoadingOver";
import { Content } from "./styles";
import Stats from "../../services/Stats";

export const EligibilityManagement = () => {
  const [loading, setLoading] = useState(false);
  const embedContainer = useRef();
  const dashboard = useRef();

  const getData = async () => {
    setLoading(true);
    const tab = "eligibility_management";
    try {
      const data = await Stats.getQSEmbed(tab, 'multi');

      embedContainer.current.innerHTML = "";
      dashboard.current = embedDashboard({
        url: data.embed_url,
        container: embedContainer.current,
        scrolling: "no",
        errorCallback: () => setLoading(false),
        loadCallback: () => setLoading(false),
        height: "AutoFit",
        loadingHeight: "750px",
        width: "100%",
        locale: "pt-BR",
        footerPaddingEnabled: true,
        undoRedoDisabled: true,
        resetDisabled: true,
      });
    } catch (e) {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <Box
        noPadding
        noHeader
        style={{ overflow: "hidden", position: "relative", overflow: "none" }}
      >
        <Content>
          {loading && <LoadingOver loading={loading} />}
          <div ref={embedContainer}></div>
        </Content>
      </Box>
    </>
  );
};
